import { axiosInstance } from '../clients/axiosClient';
import {
  API_V1_PREFIX,
  APPOINT_API_PREFIX,
  BIOMARKERS_API_PREFIX,
  COUNTERS_API_PREFIX,
  TEST_RESULTS_API_PREFIX
} from '../utils/constants';
import {
  CountUnprocessedBiomarkerResultsResponse,
  CreateBiomarkerResultRequest,
  CreateBiomarkerResultResponse,
  HTTPValidationError,
  UpdateBiomarkerResultRequest,
  UpdateBiomarkerResultResponse
} from '../types/apiGeneratedTypes';

export const addTestResults = async (
  testResultRequestObject: CreateBiomarkerResultRequest
): Promise<CreateBiomarkerResultResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${BIOMARKERS_API_PREFIX}result`,
      testResultRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
export const updateTestResults = async (
  testResultRequestObject: UpdateBiomarkerResultRequest
): Promise<UpdateBiomarkerResultResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${BIOMARKERS_API_PREFIX}result`,
      testResultRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getMemberTestResults = async (member_id: string) => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${TEST_RESULTS_API_PREFIX}list?member_id=${member_id}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getMemberSingleTestResult = async (
  appointment_id: string
): Promise<any> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${APPOINT_API_PREFIX}test-results?appointment_id=${appointment_id}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const deleteTestResults = async (result_ids: number[]): Promise<any> => {
  try {
    await axiosInstance.delete(
      `${API_V1_PREFIX}${BIOMARKERS_API_PREFIX}result`,
      {
        data: {
          result_ids
        }
      }
    );
    return true;
  } catch (error: any) {
    throw new Error(error);
  }
};

// export const getUnprocessedTestResults = async (): Promise<any> => {
//   try {
//     const { data } = await axiosInstance.get(
//       `${API_V1_PREFIX}${TEST_RESULTS_API_PREFIX}list-unprocessed`
//     );

//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// };

export const getTestResult = async (test_result_id: number): Promise<any> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${TEST_RESULTS_API_PREFIX}${test_result_id}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getUnprocessedTestResultsCount =
  async (): Promise<CountUnprocessedBiomarkerResultsResponse> => {
    try {
      const { data } = await axiosInstance.get(
        `${API_V1_PREFIX}${COUNTERS_API_PREFIX}unprocessed-count`
      );

      return data;
    } catch (error: any) {
      throw new Error(error);
    }
  };

export const setany = async (requestObject: any): Promise<any> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${TEST_RESULTS_API_PREFIX}status`,
      requestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const editTestResult = async (requestObject: any): Promise<any> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${TEST_RESULTS_API_PREFIX}edit`,
      requestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
